<template>
	<div class="c-map">
		<div v-if="nextContent !== ''" class="c-map__skip">
			<a :href="'#' + nextContent">Hoppa över karta</a>
		</div>
    	<div class="c-map__container" :id="mapName" :style="'min-height:' + height + 'px'"></div>
	</div>
</template>

<script>
export default {
    name: 'VMap',
    props: {
        objects: {
            type: Array,
            default: () => []
        },
        name: {
            type: String,
            default: 'googleMap'
        },
		height: {
			type: String,
			default: '320'
		},
		nextContent: {
			type:String,
			default: ''
		}
    },
    data() {
        return {
            mapName: this.name + "-map",
            markers: [],
            map: {},
            bounds: {},
            openInfoWindow: null,
        }
    },
    watch: {
        objects: function (val) {
            this.drawMarkers();
        }
    },
    methods: {
        createMap() {
            this.bounds = new google.maps.LatLngBounds();
            const element = document.getElementById(this.mapName);
            const options = {
                zoom: 15,
				minZoom: 8,
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                center: {
                    lat: 55.609153,
                    lng: 13.002983
                }
            };
            this.map = new google.maps.Map(element, options);
			this.drawMarkers();
        },
        clearMarkers() {
            this.markers.map(m => {if (m) m.setMap(null)});
            this.markers = [];
        },
        drawMarkers() {
            this.clearMarkers();
            this.objects.map(object => {
                this.markers.push(this.createMarker(object));
            });
        },
        createMarker(object) {
			if (object.latitude === 0 || object.longitude === 0) return;
            let position = {
                lat: object.latitude,
                lng: object.longitude
            };
            let marker = new google.maps.Marker({
                position: position,
                icon: {
                    scaledSize: new google.maps.Size(42, 51),
                    url: 'data:image/png;base64,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',

                },
                map: this.map
            });

			let objectType = (object.facts.find(fact => fact.name === 'type')) ? (object.facts.find(fact => fact.name === 'type')).displayValue : '';
			let objectArea = (object.facts.find(fact => fact.name === 'area')) ? (object.facts.find(fact => fact.name === 'area')).displayValue : '';
			let typeAndArea = (objectType && objectArea) ? objectType + '&nbsp;&middot;&nbsp;' + objectArea : objectType+objectArea;

            let infoWindow = new google.maps.InfoWindow({
                content: '<div class="c-map__infocontent"><div class="c-map__infocontent-image" style="background-image:url(' + object.imageUrl + ')"></div><div class="c-map__infocontent-text"><p class="c-map__infocontent-text-heading">' +
                    object.address + '</p><p class="c-map__infocontent-text-line">' + ((object.district) ? object.district : '') + '</p><p class="c-map__infocontent-text-line">' + typeAndArea + '</p><a href="' + object.url + '">Läs mer</a></div></div>'
            });

            marker.addListener('click', () => {
                if (this.openInfoWindow) {
                    this.openInfoWindow.close();
                }
                this.openInfoWindow = infoWindow;
                infoWindow.open(this.map, marker);
            });

            google.maps.event.addListener(this.map, 'click', function (event) {
                infoWindow.close();
            });

            this.map.fitBounds(this.bounds.extend(position));

            return marker;
		}
    },
    mounted() {
        this.createMap();
    }
}
</script>
